import React from "react";

const ResultsStepCard = ({ processId, isCreatingRoutes, onProcessComplete, processResults, updateCanProceed }) => {
  React.useEffect(() => {
    if (updateCanProceed) {
      updateCanProceed(!isCreatingRoutes && !processId);
    }
  }, [updateCanProceed, isCreatingRoutes]);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "300px",
        padding: "40px",
        background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
        borderRadius: "20px",
        color: "white",
        textAlign: "center",
        boxShadow: "0 20px 40px rgba(0,0,0,0.1)",
        position: "relative",
        overflow: "hidden",
        marginTop: "40px",
      }}
    >
      {/* Background Pattern */}
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background:
            "url(\"data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.1'%3E%3Ccircle cx='30' cy='30' r='2'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E\")",
          opacity: 0.3,
        }}
      />

      {isCreatingRoutes || processId ? (
        <>
          {/* Loading Animation */}
          <div
            style={{
              width: "80px",
              height: "80px",
              border: "4px solid rgba(255,255,255,0.3)",
              borderTop: "4px solid white",
              borderRadius: "50%",
              animation: "spin 1s linear infinite",
            }}
          />

          <h2
            style={{
              fontSize: "2.5rem",
              marginTop: "20px",
              marginBottom: "20px",
              fontWeight: "300",
              textShadow: "0 2px 4px rgba(0,0,0,0.3)",
            }}
          >
            🚀 Creating Your Routes
          </h2>

          <p
            style={{
              fontSize: "1.2rem",
              opacity: 0.9,
              maxWidth: "400px",
              lineHeight: "1.6",
            }}
          >
            Our algorithms are analyzing your data and creating the perfect routes for your passengers...
          </p>

          {/* Progress Dots */}
          <div
            style={{
              display: "flex",
              gap: "8px",
              marginTop: "30px",
            }}
          >
            {[1, 2, 3].map((dot, index) => (
              <div
                key={index}
                style={{
                  width: "12px",
                  height: "12px",
                  borderRadius: "50%",
                  background: "white",
                  animation: `pulse ${1.5 + index * 0.2}s ease-in-out infinite`,
                }}
              />
            ))}
          </div>
        </>
      ) : (
        <>
          {/* Success Icon */}
          <div
            style={{
              width: "100px",
              height: "100px",
              background: "rgba(255,255,255,0.2)",
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              animation: "bounceIn 0.8s ease-out",
            }}
          >
            <span style={{ fontSize: "3rem" }}>✨</span>
          </div>

          <h2
            style={{
              fontSize: "2.5rem",
              marginBottom: "20px",
              marginTop: "20px",
              fontWeight: "300",
              textShadow: "0 2px 4px rgba(0,0,0,0.3)",
            }}
          >
            Routes Ready!
          </h2>

          <p
            style={{
              fontSize: "1.2rem",
              opacity: 0.9,
              maxWidth: "400px",
              lineHeight: "1.6",
              marginBottom: "30px",
              marginTop: "0px",
            }}
          >
            Your routes have been successfully created. Click View Routes to view and manage them.
          </p>

          {/* Action Button */}
          <button
            style={{
              background: "rgba(255,255,255,0.2)",
              border: "2px solid white",
              color: "white",
              padding: "15px 30px",
              borderRadius: "25px",
              fontSize: "1.1rem",
              cursor: "pointer",
              transition: "all 0.3s ease",
              backdropFilter: "blur(10px)",
            }}
            onMouseEnter={(e) => {
              e.target.style.background = "rgba(255,255,255,0.3)";
              e.target.style.transform = "translateY(-2px)";
            }}
            onMouseLeave={(e) => {
              e.target.style.background = "rgba(255,255,255,0.2)";
              e.target.style.transform = "translateY(0)";
            }}
            onClick={async () => {
              if (onProcessComplete) {
                await onProcessComplete(processResults);
              }
            }}
          >
            🎯 View Routes
          </button>
        </>
      )}

      <style>{`
				@keyframes spin {
					0% { transform: rotate(0deg); }
					100% { transform: rotate(360deg); }
				}
				
				@keyframes pulse {
					0%, 100% { opacity: 0.4; transform: scale(1); }
					50% { opacity: 1; transform: scale(1.2); }
				}
				
				@keyframes bounceIn {
					0% { transform: scale(0.3); opacity: 0; }
					50% { transform: scale(1.05); }
					70% { transform: scale(0.9); }
					100% { transform: scale(1); opacity: 1; }
				}
			`}</style>
    </div>
  );
};

export default ResultsStepCard;
